import { bufferToHex } from '../bufferToHex';

type P256SignParams = {
  message: string;
  privateKeyJwk: JsonWebKey;
};

export const p256Sign = async ({ privateKeyJwk, message }: P256SignParams) => {
  const privateKey = await crypto.subtle.importKey(
    'jwk',
    privateKeyJwk,
    {
      name: 'ECDSA',
      namedCurve: 'P-256',
    },
    false,
    ['sign']
  );

  const signature = await crypto.subtle.sign(
    {
      hash: 'SHA-256',
      name: 'ECDSA',
    },
    privateKey,
    new TextEncoder().encode(message)
  );

  return bufferToHex(signature);
};
